const en = {
  demo: {
    title: `English`,
  },

  Home: `Home`,
  Dashboard: `Dashboard`,
  description: `description`,
  Description: `Description`,
  Details: `Details`,
  Book: `Book`,
  Books: `Books`,
  Invoices: `Invoices`,
  Theme: `Theme`,
  Settings: `Settings`,
  "Theme Settings": `Theme Settings`,
  Pages: `Pages`,
  Product: `Product`,
  Contacts: `Contacts`,
  "Account Settings": `Account Settings`,
  More: `More`,
  Profile: `Profile`,
  Logout: `Logout`,
  Add: `Add`,
  "Add To Cart": `Add To Cart`,
  "Buy Now": `Buy Now`,
  "Save Changes": `Save Changes`,
  "Are you sure want to delete": `Are you sure want to delete`,
  "Create Success!": `Create Success!`,
  "Update Success!": `Update Success!`,
  "Book Name": `Book Name`,
  "New Book": `New Book`,
  "Create Book": `Create Book`,
  "Create a new book": `Create a new book`,
  "Edit Book": `Edit Book`,
  "Regular Price": `Regular Price`,
  "Book Details": `Book Details`,
  "Item for Approval": `Item for Approval`,
  "Are you sure want to approve this item?": `Are you sure want to approve this item?`,
  "First Name": `First Name`,
  "Last Name": `Last Name`,
  "Email Address": `Email Address`,
  "Phone Number": `Phone Number`,
  "Please Select Country Code": `Please Select Country Code`,
  "State/Region": `State/Region`,
  "Zip/Code": `Zip/Code`,
  "Please Select a Role": `Please Select a Role`,
  "User: List | Minimal UI": `User: List | Minimal UI`,
  "User List": `User List`,
  "New User": `New User`,
  "No Data": `No Data`,
  Email: `Email`,
  Gender: `Gender`,
  Country: `Country`,
  State: `State`,
  City: `City`,
  Role: `Role`,
  Company: `Company`,
  Address: `Address`,
  Verified: `Verified`,
  Images: `Images`,
  Save: `Save`,
  Cancel: `Cancel`,
  Quantity: `Quantity`,
  Color: `Color`,
  Size: `Size`,
  Name: `Name`,
  Status: `Status`,
  Price: `Price`,
  "Created At": `Created At`,
  delete_confirmation: `Are you sure you want to delete {{value1}} item?`,
  approve_success: `Your {{value1}} book is approved`,
  app: `app`,
  User: `User`,
  Users: `Users`,
  items: `items`,
  list: `list`,
  Edit: `Edit`,
  Delete: `Delete`,
  Share: `Share`,
  Notification: `Notification`,
  Notifications: `Notifications`,
  Sort: `Sort`,
  Search: `Search`,
  Filter: `Filter`,
  Approved: `Approved`,
  Approve: `Approve`,
  analytics: `Analytics`,
  ecommerce: `e-commerce`,
  Management: `Management`,
  Title: `Title`,
  Date: `Date`,
  Time: `Time`,
  "Detail user": `Detail user`,
  "Edit user": `Edit user`,
  "Create a new user": `Create a new user`,
  "Create User": `Create User`,
  "Approve this User?": `Approve this User?`,
  "Enabling this will now allow user to login.": `Enabling this will now allow user to login.`,
  "Activate this account?": `Activate this account?`,
  "Disabling this will deactivate users account.": `Disabling this will deactivate users account.`,
  "First Name is required": `First Name is required`,
  "Email is required": `Email is required`,
  "Email must be a valid email address": `Email must be a valid email address`,
  "Phone number is required": `Phone number is required`,
  "Role is required": `Role is required`,
  "Name is required": `Name is required`,
  "Price should not be $0.00": `Price should not be $0.00`,
  "Description is required": `Description is required`,
  Transactions : 'Transactions'
};

export default en;
